import { useMemo } from 'react';
import moment from "moment";
import { Helmet } from 'react-helmet';
import { Link, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { GetAllPermissions, GetSingleRole } from '../../../../Api/role';
import BackButton from '../../../../Components/BackButton';

const RoleDetail = () => {
    const location = useLocation();
    const id = location?.state?.id;

    const { data: roleRes, isFetching } = useQuery({
        enabled: !!id,
        queryKey: ['role-detail', id],
        queryFn: () => GetSingleRole({ Id: id }),
    });

    const { data: permsRes } = useQuery({
        queryKey: ['role-detail-perms'],
        queryFn: () => GetAllPermissions(),
    });

    const role = roleRes?.data?.data || {};
    const allPermissions = permsRes?.data?.rows || [];
    const rolePermSet = useMemo(() => new Set((role?.permissions || []).map(String)), [role]);

    const permissionsByModel = useMemo(() => {
        const grouped = {};
        (allPermissions || []).forEach((p) => {
            const key = p?.modelName || 'Other';
            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(p);
        });
        return grouped;
    }, [allPermissions]);

    return (
        <>
            <Helmet>
                <title>OVE | Role Detail</title>
            </Helmet>
            <div className='page-wrapper'>
                <div className='content container-fluid'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card card-border overflow-visible'>
                                <div className='card-body'>
                                    <div className='page-header d-block'>
                                        <div className='row'>
                                            <div className='col'>
                                                <h3 className='page-title'>Role Detail</h3>
                                            </div>
                                            <div className='col-auto d-flex align-items-center justify-content-center'>
                                                <BackButton to='/admin/role-listing' />
                                            </div>
                                        </div>
                                    </div>

                                    {isFetching ? (
                                        <div className='loader-wraper'>
                                            <div className='spinner-border text-light' role='status' />
                                        </div>
                                    ) : (
                                        <>
                                            <section className='section-border mb-3'>
                                                <div className='row gy-3'>
                                                    <div className='col-md-4'>
                                                        <div className='detail-box'>
                                                            <div className='detail-label'>Name</div>
                                                            <div className='detail-value'>{role?.name || '-'}</div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='detail-box'>
                                                            <div className='detail-label'>Status</div>
                                                            <div className={`detail-value ${role?.status ? "text-success" : "text-danger"}`}>{role?.status ? 'Active' : 'Inactive'}</div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='detail-box'>
                                                            <div className='detail-label'>Created</div>
                                                            <div className='detail-value'>{role?.createdAt ? moment(role.createdAt).format("DD/MM/YYYY HH:mm") : '-'}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>

                                            <section className='section-border'>
                                                <h5 className='mb-3'>Permissions</h5>
                                                <div className='row'>
                                                    {Object.keys(permissionsByModel).map((group) => (
                                                        <div className='col-md-4 mb-3' key={group}>
                                                            <div className='card h-100'>
                                                                <div className='card-header py-2'><strong>{group}</strong></div>
                                                                <div className='card-body' style={{ paddingLeft: 12 }}>
                                                                    {permissionsByModel[group].map((perm) => {
                                                                        const isSelected = rolePermSet.has(String(perm?._id));
                                                                        return (
                                                                            <div className='d-flex align-items-center gap-2' key={String(perm?._id)}>
                                                                                <span className={`badge ${isSelected ? 'bg-success' : 'bg-secondary'}`}>{isSelected ? 'Yes' : 'No'}</span>
                                                                                <span>{perm?.name}</span>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </section>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RoleDetail;


